// utils/PaginacaoUtils.js

// Configurações de paginação
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 6, // Tamanho padrão de itens por página
  DEFAULT_FIRST_PAGE: 0, // Índice da primeira página (normalmente 0 para APIs baseadas em zero)
};

export default PAGINATION;

/**
 * Adiciona um item a uma lista paginada, criando nova página se necessário.
 * @param {Array} listaAtual Lista de itens já cadastrados
 * @param {any} novoItem Item a ser adicionado
 * @param {number} tamanhoPagina Quantidade de itens por página (default: 6)
 * @returns {Array[]} Lista paginada (array de arrays)
 */
export function adicionarItemPaginado(listaAtual, novoItem, tamanhoPagina = 6) {
    const novaLista = [...listaAtual, novoItem];
    const paginas = [];
    for (let i = 0; i < novaLista.length; i += tamanhoPagina) {
        paginas.push(novaLista.slice(i, i + tamanhoPagina));
    }
    return paginas;
}

/**
 * Gera páginas a partir de uma lista (sem adicionar item extra)
 * @param {Array} lista Lista de itens
 * @param {number} tamanhoPagina Tamanho da página
 * @returns {Array[]} Lista paginada
 */
export function paginarLista(lista, tamanhoPagina = 6) {
    const paginas = [];
    for (let i = 0; i < lista.length; i += tamanhoPagina) {
        paginas.push(lista.slice(i, i + tamanhoPagina));
    }
    return paginas;
}

/**
 * Utilitário para obter a página atual de acordo com o índice.
 * @param {Array[]} paginas Lista paginada
 * @param {number} paginaAtual Índice da página desejada
 * @returns {Array} Itens da página
 */
export function obterPagina(paginas, paginaAtual) {
    return paginas[paginaAtual] || [];
}
